// translations.js
const translations = {
    english: {
        lectureVideo: "Lecture Video",
        skit: "Skit",
        writingPractice: "Writing Practice",
        takeQuiz: "Take Quiz",
        submit: "Submit",
        skipToNext: "Skip to Next",
        wantToReattempt: "Want to reattempt",
        dontWantToReattempt: "Don't want to reattempt",
        moveToNext: "Move to Next",
        backToHome: "Back To Home",
        chooseLearningModule: "Choose Your Learning Module",
        Selectthecorrecttranslation:"Select the correct translation",
        leactureVideo: "Lecture Video",
        overallProgress : "Overall Progress",
        backgroundVoice: "Background voice",
        peopleVoice: "People’s voice",
        glossary: "Glossary",
        nextDay : "Next Day",
        exploreProfessionals: "Explore life of other Professionals",
        startQuiz: "Start quiz",
        moveToNextDay: "Move to next day",
        reattempt: "Reattempt",
        startLearning: "Start Your Learning Journey",
        welcomeBack: "Welcome back!",
        continueLearningJourney: "Let's continue your learning journey",
        nowStudying: "Now Studying",
        loading: "Loading...",
        stage: "Stage",
        lesson: "Lesson",
        section: "Section",
        goToCurrentSection: "Go to Current Section",
        moveToNextSection: "Move to Next Section",
        studyTime: "Study Time",
        trackStudyTimeComingSoon: "Track your study time — coming soon ⏳",
        Home:"Home",
        learning:"Study Material",
        go: "Go Japan",
        profile: "Profile",
        payment: "Payment",
        startsOn: "Starts on",
        expiresOn: "Expires on",
        quizType: "Quiz Type",
        startNow: "Start Now",
		statisticsAndResults: "Statistics And Results",
		sorry: "Sorry!",
		returnBackToHome: "Return Back to Home",
		feedback: "Feedback",
		userExperienceSatisfaction: "User Experience Satisfaction",
		attachImage: "Attach Image",
		uploadImage: "Upload Image",
		selectYourJourney: "Select Your Journey",
		studyInJapan: "Study in Japan",
		discoverJobOpportunities: "Discover Job Opportunities",
		personName: "Person Name",
		email: "Email",
		location: "Location",
		date: "Date",
		time: "Time",
		confirm: "Confirm",
		totalAttempted: "Total Attempted",
		quizResult: "Quiz Result",
		quiz: "Quiz",
		selectTheCorrectTranslation: "Select the correct translation",
		incorrect: "Incorrect",
		correct: "Correct",
		pleaseSelectAnAnswer: "Please select an answer",
		explanation: "Explanation",
		dontWantToReattempt: "Don’t Want to Reattempt",
		wantToReattempt: "Want to Reattempt",
		skipToNext: " Skip to Next",
		quizResults: "Quiz Results for",
		skipped: "Skipped",
		returnBackToQuiz: "Return Back to Quiz",
		listeningQuiz: "Listening Quiz",
		writingQuiz: "Writing Quiz",
		drawingPractice: "Drawing Practice",
		characterLearning: "Character Learning",
		nextQuestion: "Next Question",
		question: "Question",
		next: "Next",
		ChooseTheProfessionYouWantToLearnAboutInJapan: "Choose the Profession you want to learn about in Japan",
		nextQuiz: "Next Quiz",
		comingSoon: "Coming Soon",
		uhohPleaseVisitLater: "Uh oh! Please Visit Later",
		visited: "Visited",
		back: "Back",
		flipCard: "Flip Card",
		youveCompletedTheQuiz: "You've Completed the Quiz!",
		startAnotherFlashCard: "Start Another Flash Card",
		youveCompletedTheSkit: "You've Completed the Skit!",
		hours: "Hours",
		UhohThereAreNoQuestions: " Uh oh! There are no questions of the selected type! Please answer more questions in the quiz and return to check for",
		chatFromSupervisor: "Chat from Supervisor",
		goToGroupChat: "Go to Group Chat",
		LessonList: "Lesson list",
		NewLearningPath: "New Learning path",
		currentPlan: "Current Active Plan",
		upcomingPlans: "Upcoming Plans",
		daysLeft: "{days} Days Left",
		days: "Days",
		off: "OFF",
		save: "Save",
		monthly: "/monthly",
		payNow: "Pay Now",
		expired: "Expired",
		subscribtion: "Days Left",
		Learned: "Learned",
    },
    hindi: {
        quizType: "अभ्यास के प्रकार",
        profile: "प्रोफाइल",
        go:"चलो जापान",
        learning: "पढ़ाई की चीज़ें",
        Home:"होम",
        payment: "भुगतान",
        startsOn: "शुरू होगा",
        expiresOn: "समाप्त होगा",
        startLearning:"पढ़ना शुरू करें",
        welcomeBack: "फिर से स्वागत है!",
        continueLearningJourney: "चलिए सीखना जारी रखें",
        nowStudying: "अभी सीख रहे हैं",
        loading: "लोड हो रहा है...",
        stage: "लेवल",
        lesson: "पाठ",
        section: "हिस्सा",
        goToCurrentSection: "अभी वाले हिस्से पर जाएँ",
        moveToNextSection: "अगले हिस्से पर जाएँ",
        studyTime: "पढ़ाई का समय",
        trackStudyTimeComingSoon: "अपनी पढ़ाई का समय देखें — जल्द आ रहा है ⏳",
        lectureVideo: "क्लास विडियो",
        skit: "कहानियों से शब्द सीखें",
        writingPractice: "लिखने का अभ्यास",
        takeQuiz: "अभ्यास (प्रशन उत्तर)",
        submit: "जवाब भेजें",
        skipToNext: "अगले सवाल पर जाएं",
        wantToReattempt: "फिर से प्रयास करना चाहते हैं",
        dontWantToReattempt: "फिर से प्रयास नहीं करना चाहते हैं",
        moveToNext: "अगले पर जाएं",
        backToHome: "वापस जाओ",
        chooseLearningModule: "पढ़ाई शुरू करने के लिए दिन चुनें",
        Selectthecorrecttranslation:"सही अनुवाद चुनें",
        leactureVideo: "क्लास विडियो",
        overallProgress: "कुल प्रयास किये गये प्रश्न",
        backgroundVoice: "फोटो की पीछे की कहानी",
        peopleVoice: "फोटो में बोलते हुए लोगों की आवाज़",
        glossary: "शब्दकोष",
        nextDay: "अगले दिन",
        exploreProfessionals: "दूसरे लोगों की दिनचर्या से सीखें",
        startQuiz: "पढ़ना शुरू करें",
        moveToNextDay: "अगले दिन पर जाएं",
        reattempt: "पुनः प्रयास करें",
        startNow: "शुरू करें",
		statisticsAndResults: "आंकड़े और परिणाम",
		sorry: "क्षमा करें!",
		returnBackToHome: "वापस जाये",
		feedback: "सुझाव",
		userExperienceSatisfaction: "उपयोगकर्ता अनुभव संतुष्टि",
		attachImage: "छवि संलग्न करें",
		uploadImage: "तस्विर अपलोड करे",
		selectYourJourney: "अपनी यात्रा चुनें",
		studyInJapan: "विदेश में पढाई",
		discoverJobOpportunities: "विदेश में नौकरी",
		personName: "व्यक्ति का नाम",
		email: "ईमेल",
		location: "जगह",
		date: "तारीख",
		time: "समय",
		confirm: "पुष्टि करें",
		quizType: "अभ्यास के प्रकार",
		totalAttempted: "कुल प्रयास",
		quizResult: "प्रश्न और उत्तर परिणाम",
		quiz: "प्रश्नोत्तरी",
		selectTheCorrectTranslation: "सही अनुवाद चुने",
		incorrect: "ग़लत",
		correct: "सही",
		pleaseSelectAnAnswer: "कृपया एक उत्तर चुनें",
		explanation: "स्पष्टीकरण",
		dontWantToReattempt: "फिर से प्रयास नहीं करना चाहते हैं",
		wantToReattempt: "फिर से प्रयास करना चाहते हैं",
		skipToNext: "अगले सवाल पर जाएं",
		quizResults: "क्विज़ परिणाम",
		skipped: "छोड़ा गया",
		returnBackToQuiz: "प्रश्नोत्तरी पर वापस लौटें",
		listeningQuiz: "सुनने संबंधी प्रश्नोत्तरी",
		writingQuiz: "लिखने का अभ्यास",
		drawingPractice: "ड्राइंग अभ्यास",
		characterLearning: "शब्द सीखना",
		nextQuestion: "अगला सवाल",
		question: "प्रश्न",
		next: "अगला",
		ChooseTheProfessionYouWantToLearnAboutInJapan: "जापान में जिस पेशे के बारे में आप सीखना चाहते हैं उसे चुनें",
		nextQuiz: "अगला प्रश्नोत्तरी",
		comingSoon: "जल्द आ रहा है",
		uhohPleaseVisitLater: "ओह ओह! कृपया बाद में आइये",
		visited: "दौरा किया",
		back: "पीछे",
		flipCard: "फ्लिप कार्ड",
		youveCompletedTheQuiz: "आपने प्रश्न और उत्तर पूरा कर लिया है",
		startAnotherFlashCard: "दूसरा फ़्लैश कार्ड प्रारंभ करें",
		youveCompletedTheSkit: "आपने स्किट पूरा कर लिया है!",
		hours: "घंटे",
		UhohThereAreNoQuestions: "ओह ओह! चुने गए प्रकार के कोई प्रश्न नहीं हैं! कृपया क्विज़ में और अधिक प्रश्नों के उत्तर दें और की जाँच करने के लिए वापस आएँ।",
		chatFromSupervisor: "सुपरवाइजर से चैट",
		goToGroupChat: "ग्रुप चैट पर जाएं",
		LessonList: "पाठ सूची",
		NewLearningPath: "नया लर्निंग पाथ",
		currentPlan: "सक्रिय प्लान",
		upcomingPlans: "आगामी प्लान",
		daysLeft: "{days} दिन बचे हैं",
		days: "दिन",
		off: "OFF",
		save: "बचत",
		monthly: "/मासिक",
		payNow: "अभी भुगतान करें",
		expired: "समाप्त",
		subscribtion: "बचे हुए दिन",
		Learned: "सीख लिया",
    }
};

export default translations;
